import React from "react";
import {withRouter} from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";


import PracticeSettings from "views/Components/PracticeSettings.jsx"

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  ...customSelectStyle,
  ...regularFormsStyle
};

class Options extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showInSearch: true,
      acceptCreditCards: false,
      allowMonthlyPlans: true,
      allowAnnualPlans: false,
      chargeCreditCardFee: false
    };
  }
  sendState() {
    return this.state;
  }

  updateOption(field, value) {
    this.setState({
      [field]: value
    });
  }

  isValidated() {
    return true;
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>Please select the options for your account.</h4>
          <h4 style={{fontSize: "100%"}} className={classes.infoText}>You'll be able to change these later.</h4>
        </GridItem>
        <PracticeSettings
          updateOption={this.updateOption.bind(this)}
          showInSearch={this.state.showInSearch}
          acceptCreditCards={this.state.acceptCreditCards}
          allowMonthlyPlans={this.state.allowMonthlyPlans}
          allowAnnualPlans={this.state.allowAnnualPlans}
          chargeCreditCardFee={this.state.chargeCreditCardFee}
          showUpdatePatientAgreementButton={false}
          />

      </GridContainer>
    );
  }
}

export default withRouter(withStyles(style)(Options));
